import { USER_ROLES } from "../constants";
import { PERSONA_LIMIT } from "../constants/persona";

export const getPersonaLimit = (role?: string) => {
  switch (role) {
    case USER_ROLES.MINIMAL:
      return PERSONA_LIMIT.PAID_MINIMAL;
    case USER_ROLES.BASIC:
      return PERSONA_LIMIT.PAID_BASIC;
    case USER_ROLES.PREMIUM:
      return PERSONA_LIMIT.PAID_PREMIUM;
    default:
      return PERSONA_LIMIT.FREE;
  }
};
